/**
 * Erkennt die aktuelle Umgebung anhand des Hostnames.
 * - localhost / 127.* / *.local → 'local'
 * - staging-*.onvice.ai → 'staging'
 * - alles andere → 'prod'
 *
 * Ausnahme: BANNER_SILENT_HOSTS werden als 'prod' behandelt (Banner-Unterdrueckung).
 * Genutzt fuer Staging-Instanzen die als Demo-/Vorschau-System fungieren und keinen
 * "STAGING"-Balken zeigen sollen, obwohl sie technisch staging-* heissen.
 */
import { useEffect, useState } from 'react';

export type Stage = 'local' | 'staging' | 'prod';

const BANNER_SILENT_HOSTS: readonly string[] = ['staging-meiners.onvice.ai'];

function detect(): Stage {
  if (typeof window === 'undefined') return 'prod';
  const host = window.location.hostname;
  if (host === 'localhost' || host.startsWith('127.') || host.endsWith('.local')) return 'local';
  if (BANNER_SILENT_HOSTS.includes(host)) return 'prod';
  if (host.startsWith('staging-') || host.startsWith('staging.')) return 'staging';
  return 'prod';
}

let cached: Stage | null = null;
export function getStage(): Stage {
  if (cached === null) cached = detect();
  return cached;
}

/** React-Hook für Komponenten. */
export function useStage(): Stage {
  const [stage] = useState<Stage>(getStage);
  return stage;
}

/** Setzt document.title mit Stage-Prefix (nur lokal + staging). */
export function useStageDocumentTitle(baseTitle: string): void {
  useEffect(() => {
    const stage = getStage();
    const prefix = stage === 'local' ? '[LOKAL] ' : stage === 'staging' ? '[STAGING] ' : '';
    document.title = `${prefix}${baseTitle}`;
  }, [baseTitle]);
}
